import { GotoAction, SimpleRouterNavigationExtras } from '@platform-frontend/util';
import { UserType } from '../academic/model/user-type';
import { AppFlow } from './model/app-flow';
import { RefreshCheckoutMessageParams } from './model/checkout-sanitized-start-params';

export class SetFlow {
  static readonly type = '[Flow] Set flow';
  constructor(public flow: AppFlow) {}
}

export class PatchContractId {
  static readonly type = '[Flow] Patch contract ID';
  constructor(public contractId: string | null) {}
}

export class PrepareFlow {
  static readonly type = '[Flow] Prepare flow';
}

export class FlowPreparationStarted {
  static readonly type = '[Flow] Flow preparation started';
  constructor(public flow: AppFlow) {}
}

export class StartFlow {
  static readonly type = '[Flow] Start flow';
}

export class FetchFlowData {
  static readonly type = '[Flow] Fetch flow data started';
  constructor(public flow: AppFlow) {}
}

export class PublishFetchedFlowData {
  static readonly type = '[Flow] Publish feteched flow data';
}

export class FlowStarted {
  static readonly type = '[Flow] Flow started';
  constructor(public flow: AppFlow) {}
}

export class FlowCanceled {
  static readonly type = '[Flow] Flow canceled';
}

export class SetAcademicUserType {
  static readonly type = '[Flow] Set academic user type';
  constructor(public userType: UserType) {}
}

export class GotoFlowStart extends GotoAction {
  static readonly type = '[Flow] Goto flow start';
}

export abstract class GotoCheckoutFlowAction extends GotoAction {
  constructor(public startParams: RefreshCheckoutMessageParams, public extras?: SimpleRouterNavigationExtras) {
    super(extras);
  }
}
